import { styled } from '@linaria/react';

import { BREAKPOINTS } from '@/constants';

import { BaseWrapper as AsideWrapper } from '@/components/Aside';
import { Wrapper as BlockquoteWrapper } from '@/components/Blockquote';
import { Wrapper as TweetWrapper } from '@/components/FakeTweet';

export default styled.p`
  font-size: var(--paragraph-font-size-override, 1.125rem);
  margin-bottom: 1.25em;

  ${AsideWrapper} & {
    font-size: 1rem;

    &:last-child {
      margin-bottom: 0;
    }
  }

  ${BlockquoteWrapper} & {
    @media ${BREAKPOINTS.mdAndLarger} {
      text-wrap: balance;
      text-align: center;
    }
  }

  ${TweetWrapper} & {
    font-size: 1rem;
  }
`;
